'use client';

import { Box, Typography, Avatar } from '@mui/material';

interface AuthorInfoProps {
  name: string;
  date: string;
  readingTime?: string | undefined;
  locale: string;
}

/**
 * AuthorInfo - Displays author name, publish date, and reading time.
 */
export function AuthorInfo({ name, date, readingTime, locale }: AuthorInfoProps) {
  const formattedDate = new Date(date).toLocaleDateString(
    locale === 'he' ? 'he-IL' : locale === 'es' ? 'es-ES' : 'en-US',
    { year: 'numeric', month: 'long', day: 'numeric' }
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
      <Avatar
        sx={{
          width: 40,
          height: 40,
          bgcolor: 'primary.main',
          fontSize: '0.9rem',
          fontWeight: 600,
        }}
      >
        {name
          .split(' ')
          .map((n) => n[0])
          .join('')
          .toUpperCase()
          .slice(0, 2)}
      </Avatar>
      <Box>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
          {name}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {formattedDate}
          {readingTime && ` · ${readingTime}`}
        </Typography>
      </Box>
    </Box>
  );
}
